<template>
  <div data-v-5e89786c="" class="contents">
    <nav data-v-5e89786c="" class="nav_mobile_top">
      <div data-v-5e89786c="" class="nav_content">
        <div data-v-5e89786c="" class="nav_left nav_left1">
          <div data-v-5e89786c="" class="back" @click="$router.go(-1)">
            <img
              data-v-5e89786c=""
              src="../../assets/img/arrow_back.d5eef796-0de7d3ca.svg"
              alt=""
            />
          </div>
          <div data-v-5e89786c="" class="nav_name2">
            {{ $t('optionorder') }}
          </div>
          <div data-v-5e89786c="" class="start"></div>
        </div>
      </div>
    </nav>
    <div data-v-5e89786c="" class="empty-box"></div>
    <van-loading
      class="loading"
      type="spinner"
      v-if="showloading"
      color="#c2e22a"
    />
    <div
      data-v-5e89786c=""
      class="contents-box"
      style="padding: 0px 20px"
      v-else
    >
      <div data-v-5e89786c="" class="menu-list">
        <div data-v-5e89786c="" class="menus">
          <div
            data-v-5e89786c=""
            class="menu"
            :class="selectop == 1 ? 'menu_active' : ''"
            @click="changesel(1)"
          >
            {{ $t('normalls') }}
          </div>
          <div
            data-v-5e89786c=""
            class="menu"
            :class="selectop == 2 ? 'menu_active' : ''"
            @click="changesel(2)"
          >
            {{ $t('enddd') }}
          </div>
        </div>
      </div>
      <div data-v-5e89786c="" v-if="selectop == 1">
        <div data-v-a330c516="" class="no-data" v-if="empty1">
          <div data-v-a330c516="" class="no-img">
            <img
              data-v-a330c516=""
              src="../../assets/img/no_data.78bef72c.svg"
              alt=""
              srcset=""
            />
          </div>
          <div data-v-a330c516="" class="no-title">{{ $t('aiyass') }}</div>
          <div data-v-a330c516="" class="no-info">
            {{ $t('hasnoorder') }}
          </div>
        </div>
        <div data-v-5e89786c="" v-else>
          <div data-v-5e89786c="" class="content-list" v-for="item in list">
            <div data-v-5e89786c="" class="title">{{ item.goodname }}</div>
            <div data-v-5e89786c="" class="list">
              <div data-v-5e89786c="" class="lable">{{ $t('leixing') }}</div>
              <!---->
              <div
                data-v-5e89786c=""
                class="list-content list-content1"
                v-if="item.direction === 1"
              >
                {{ $t('up') }}
              </div>
              <div
                data-v-5e89786c=""
                class="list-content list-content1"
                v-if="item.direction === 2"
              >
                {{ $t('down') }}
              </div>
            </div>
            <div data-v-5e89786c="" class="list">
              <div data-v-5e89786c="" class="lable">{{ $t('amountt') }}</div>
              <div data-v-5e89786c="" class="list-content">
                $ {{ item.money }}
              </div>
            </div>
            <div data-v-5e89786c="" class="list">
              <div data-v-5e89786c="" class="lable">{{ $t('kaipjia') }}</div>
              <div data-v-5e89786c="" class="list-content">
                {{ item.buyprice }}
              </div>
            </div>
            <div data-v-5e89786c="" class="list">
              <div data-v-5e89786c="" class="lable">
                {{ $t('curentprice') }}
              </div>
              <div data-v-5e89786c="" class="list-content">
                {{ item.close }}
              </div>
            </div>
            <div data-v-5e89786c="" class="list">
              <div data-v-5e89786c="" class="lable">{{ $t('timess') }}</div>
              <div data-v-5e89786c="" class="list-content">
                {{ item.residuetime }}{{ $t('sssstimes') }}
              </div>
            </div>
            <div data-v-5e89786c="" class="list">
              <div data-v-5e89786c="" class="lable">{{ $t('feees') }}</div>
              <div data-v-5e89786c="" class="list-content">
                ${{ item.cost }}
              </div>
            </div>
            <div data-v-5e89786c="" class="list" v-if="item.direction === 1">
              <div data-v-5e89786c="" class="lable">{{ $t('yuqis') }}</div>
              <div
                data-v-5e89786c=""
                class="list-content"
                v-if="item.close > item.buyprice"
              >
                +$ {{ item.money * item.yk_bl }}
              </div>
              <div data-v-5e89786c="" class="list-content" v-else>
                -$ {{ item.money * item.yk_bl }}
              </div>
            </div>
            <div data-v-5e89786c="" class="list" v-if="item.direction === 2">
              <div data-v-5e89786c="" class="lable">{{ $t('yuqis') }}</div>
              <div
                data-v-5e89786c=""
                class="list-content"
                v-if="item.close < item.buyprice"
              >
                +$ {{ item.money * item.yk_bl }}
              </div>
              <div data-v-5e89786c="" class="list-content" v-else>
                -$ {{ item.money * item.yk_bl }}
              </div>
            </div>
            <div data-v-5e89786c="" class="list">
              <div data-v-5e89786c="" class="lable">{{ $t('cjtimess') }}</div>
              <div data-v-5e89786c="" class="list-content">
                {{ item.addtime }}
              </div>
            </div>
          </div>
        </div>
        <!---->
      </div>
      <div data-v-5e89786c="" v-if="selectop == 2">
        <div data-v-a330c516="" class="no-data" v-if="empty2">
          <div data-v-a330c516="" class="no-img">
            <img
              data-v-a330c516=""
              src="../../assets/img/no_data.78bef72c.svg"
              alt=""
              srcset=""
            />
          </div>
          <div data-v-a330c516="" class="no-title">{{ $t('aiyass') }}</div>
          <div data-v-a330c516="" class="no-info">
            {{ $t('hasnoorder') }}
          </div>
        </div>
        <div data-v-5e89786c="" v-else>
          <div data-v-5e89786c="" class="content-list" v-for="item in list2">
            <div data-v-5e89786c="" class="title">{{ item.goodname }}</div>
            <div data-v-5e89786c="" class="list">
              <div data-v-5e89786c="" class="lable">{{ $t('leixing') }}</div>
              <!---->
              <div
                data-v-5e89786c=""
                class="list-content list-content1"
                v-if="item.direction === 1"
              >
                {{ $t('up') }}
              </div>
              <div
                data-v-5e89786c=""
                class="list-content list-content1"
                v-if="item.direction === 2"
              >
                {{ $t('down') }}
              </div>
            </div>
            <div data-v-5e89786c="" class="list">
              <div data-v-5e89786c="" class="lable">{{ $t('amountt') }}</div>
              <div data-v-5e89786c="" class="list-content">
                $ {{ item.money }}
              </div>
            </div>
            <div data-v-5e89786c="" class="list">
              <div data-v-5e89786c="" class="lable">{{ $t('kaipjia') }}</div>
              <div data-v-5e89786c="" class="list-content">
                {{ item.buyprice }}
              </div>
            </div>
            <div data-v-5e89786c="" class="list">
              <div data-v-5e89786c="" class="lable">{{ $t('jiesunajia') }}</div>
              <div data-v-5e89786c="" class="list-content">
                {{ item.sellprice }}
              </div>
            </div>
            <div data-v-5e89786c="" class="list">
              <div data-v-5e89786c="" class="lable">{{ $t('timess') }}</div>
              <div data-v-5e89786c="" class="list-content">
                {{ item.times }}{{ $t('sssstimes') }}
              </div>
            </div>
            <div data-v-5e89786c="" class="list">
              <div data-v-5e89786c="" class="lable">{{ $t('feees') }}</div>
              <div data-v-5e89786c="" class="list-content">
                ${{ item.cost }}
              </div>
            </div>
            <div data-v-5e89786c="" class="list">
              <div data-v-5e89786c="" class="lable">{{ $t('yuqis') }}</div>
              <div
                data-v-5e89786c=""
                class="list-content"
                v-if="item.yk_state === 1"
              >
                +$ {{ item.yknum }}
              </div>
              <div
                data-v-5e89786c=""
                class="list-content"
                v-if="item.yk_state === 2"
              >
                -$ {{ item.yknum }}
              </div>
            </div>
            <div data-v-5e89786c="" class="list">
              <div data-v-5e89786c="" class="lable">{{ $t('cjtimess') }}</div>
              <div data-v-5e89786c="" class="list-content">
                {{ item.addtime }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-v-5e89786c="" class="empty-box"></div>
  </div>
</template>
<script>
import '../../assets/css/index-c925edae.css'
import '../../assets/css/514.cbfba8eb.css'
export default {
  data() {
    return {
      list: [],
      list2: [],
      showloading: false,
      selectop: 1,
      empty1: true,
      empty2: true,
      timer1: null,
      timer2: null,
    }
  },
  created() {
    this.showloading = true
    this.getlist()
    this.timer1 = setInterval(this.getlist, 6000)
  },
  beforeDestroy() {
    if (this.timer1) {
      clearInterval(this.timer1)
      this.timer1 = null
    }
    if (this.timer2) {
      clearInterval(this.timer2)
      this.timer2 = null
    }
  },
  beforeRouteLeave(to, from, next) {
    next()
    if (this.timer1) {
      clearInterval(this.timer1)
      this.timer1 = null
    }
    if (this.timer2) {
      clearInterval(this.timer2)
      this.timer2 = null
    }
  },
  methods: {
    changesel(e) {
      this.selectop = e
      if (e === 1) {
        this.showloading = true
        this.getlist()
        if (this.timer1) {
          clearInterval(this.timer1)
          this.timer1 = null
        }
        if (this.timer2) {
          clearInterval(this.timer2)
          this.timer2 = null
        }
        this.timer1 = setInterval(this.getlist, 6000)
      } else {
        this.showloading = true
        this.getlist2()
        if (this.timer1) {
          clearInterval(this.timer1)
          this.timer1 = null
        }
        if (this.timer2) {
          clearInterval(this.timer2)
          this.timer2 = null
        }
        this.timer2 = setInterval(this.getlist2, 6000)
      }
    },
    async getlist() {
      const { data } = await this.$http.post('/getmyordering')
      if (data) {
        this.list = data.data
        if (this.list.length > 0) {
          this.empty1 = false
        } else {
          this.empty1 = true
        }
      }
      this.showloading = false
    },
    async getlist2() {
      const { data } = await this.$http.post('/getmyorderend')
      if (data) {
        this.list2 = data.data
        if (this.list2.length > 0) {
          this.empty2 = false
        } else {
          this.empty2 = true
        }
      }
      this.showloading = false
    },
  },
}
</script>
<style scoped lang="less">
.loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.no-data[data-v-a330c516] {
  width: 100%;
  height: 100%;
}
.no-data .no-img[data-v-a330c516] {
  width: 4rem;
  height: 4rem;
  background: #c0dd2b;
  border-radius: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  margin-top: 8rem;
}
.no-data .no-img img[data-v-a330c516] {
  width: 2rem;
}
.no-data .no-title[data-v-a330c516] {
  font-weight: 600;
  font-size: 2rem;
  color: #fff;
  margin: 0.5rem 0;
  height: 2rem;
  text-align: center;
}
.no-data .no-info[data-v-a330c516] {
  width: 18rem;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.5rem;
  text-align: center;
  color: #a6a6a6;
  mix-blend-mode: normal;
  margin: auto;
}
</style>
